<div class="campaigns-filter-container" *transloco="let t">
  <app-closable-bottom-sheet-handle (close)="close()"></app-closable-bottom-sheet-handle>
  <form [formGroup]="form" class="filter-form">
    <div class="sort-options">
      <div class="filter-title">{{ t('filters.sort.title') }}</div>
      <app-radio-buttons-question formControlName="sort" [buttonsInfo]="sortOptions"
                                  [isFlexDirectionColumn]="true">
      </app-radio-buttons-question>
    </div>
    @if (this.data.settings?.showLoyalty) {
      <div class="range-slider-container">
        <app-range-slider formControlName="loyaltyScore" [type]="RangeSliderType.LOYALTY"></app-range-slider>
      </div>
    }
    <div class="range-slider-container">
      <app-range-slider formControlName="amount" [type]="RangeSliderType.AMOUNT" [monetaryRange]="true"
                        [openMaxInterval]="true"></app-range-slider>
    </div>
  </form>
  <div class="button-row">
    <button mat-flat-button class="clear-filter-button"
            (click)="apply()">{{ t('filters.apply') }}
    </button>
    <button mat-stroked-button class="clear-filter-button" [disabled]="filterCounter == 0"
            (click)="clearFilters()">
      {{ t('filters.clear') }}
      @if (filterCounter && filterCounter > 0) {
        <span>({{ filterCounter }})</span>
      }
    </button>
  </div>
</div>
